import PropTypes from 'prop-types';
// -*- mode: jsx;-*-
import { teacherSupportCategoriesWithTYPInput } from './contactConstants.js';

export default function TeacherFormProjectFields({
    proposalId, proposalTitle, formErrors, chosenSupportCategory,
    projects, showAllProjects, filteredProjects,
    loggedInUser, handleInputChange, showAllProjectsCallback,
}) {
    return <div>
        <ProjectFields proposalId={proposalId} proposalTitle={proposalTitle}
            formErrors={formErrors}
            chosenSupportCategory={chosenSupportCategory}
            projects={projects}
            showAllProjects={showAllProjects}
            filteredProjects={filteredProjects}
            loggedInUser={loggedInUser}
            handleInputChange={handleInputChange}
            showAllProjectsCallback={showAllProjectsCallback} />
    </div>;
}
TeacherFormProjectFields.propTypes = {
    chosenSupportCategory: PropTypes.object.isRequired, // The most specific category selected
    handleInputChange: PropTypes.func.isRequired,
    showAllProjectsCallback: PropTypes.func.isRequired, // only required here because ProjectFields requires it
    formErrors: PropTypes.object.isRequired,

    // set if the teacher is logged in
    loggedInUser: PropTypes.bool,
    projects: PropTypes.array, // all of the teacher's projects
    filteredProjects: PropTypes.array, // filtered based on relevance to the chosen category

    // set if the user has selected a project
    proposalId: PropTypes.string,
    proposalTitle: PropTypes.string,

    showAllProjects: PropTypes.bool,
};

function ProjectFields({
    proposalId, proposalTitle, formErrors, chosenSupportCategory,
    projects, showAllProjects, filteredProjects,
    loggedInUser, handleInputChange, showAllProjectsCallback,
}) {
    if (loggedInUser && (filteredProjects || projects.length > 0)) {
        let options;
        if (filteredProjects && !showAllProjects) {
            options = filteredProjects.map(function (project) {
                return <option key={project.id}
                    value={project.id}>{project.id} - {project.title}</option>;
            }, this);
        } else {
            options = projects.map(function (project) {
                return <option key={project.id}
                    value={project.id}>{project.id} - {project.title}</option>;
            }, this);
        }

        return (
            <div className="input-holder">
                <label htmlFor="proposalId">Project</label>
                {/* eslint-disable-next-line jsx-a11y/no-onchange */}
                <select name="proposalId" id="proposalId" className={formErrors.proposalId ? 'hasError' : ''}
                    value={proposalId}
                    onChange={handleInputChange}>
                    <option value="">Select one</option>
                    <option value="0">N/A</option>
                    {options}
                </select>
                {formErrors.proposalId ? (
                    <div className="error-text">{formErrors.proposalId}</div>) : null}
                <ShowAllProjectsButton filteredProjects={filteredProjects}
                    showAllProjects={showAllProjects}
                    chosenSupportCategory={chosenSupportCategory}
                    showAllProjectsCallback={showAllProjectsCallback} />
            </div>
        );
    }

    return (
        <div>
            <div className="input-holder">
                <label htmlFor="proposalId">Project Id (if known)</label>
                <input type="text" name="proposalId" id="proposalId"
                    className={formErrors.proposalId ? 'hasError' : ''}
                    value={proposalId}
                    onChange={handleInputChange}
                    pattern="^[0-9]+$" title="Project ID should only contain numberical digits"/>
                {formErrors.proposalId ? (
                    <div className="error-text">{formErrors.proposalId}</div>) : null}
            </div>
            <div className="input-holder">
                <label htmlFor="proposalTitle">Project title (if known)</label>
                <input type="text" name="proposalTitle" id="proposalTitle"
                    className={formErrors.proposalTitle ? 'hasError' : ''}
                    value={proposalTitle}
                    onChange={handleInputChange}/>
                {formErrors.proposalTitle ? (
                    <div className="error-text">{formErrors.proposalTitle}</div>) : null}
            </div>
        </div>
    );
}
ProjectFields.propTypes = {
    proposalId: PropTypes.string,
    proposalTitle: PropTypes.string,
    formErrors: PropTypes.object.isRequired,
    chosenSupportCategory: PropTypes.object.isRequired,
    projects: PropTypes.array,
    showAllProjects: PropTypes.bool,
    filteredProjects: PropTypes.array,
    loggedInUser: PropTypes.bool,
    handleInputChange: PropTypes.func.isRequired,
    showAllProjectsCallback: PropTypes.func.isRequired, // could probably be optional; only used if showAllProjects == true
};

function ShowAllProjectsButton({
    filteredProjects, showAllProjects, chosenSupportCategory, showAllProjectsCallback,
}) {
    if (filteredProjects && !showAllProjects && teacherSupportCategoriesWithTYPInput[chosenSupportCategory.keyword]) {
        const showAllProjects = (event) => {
            event.preventDefault();
            showAllProjectsCallback(true);
        };

        return (
            <div>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a role="button" tabIndex={0} id="showProjects"
                    onClick={showAllProjects}
                    onKeyDown={(event) => {
                        // this handler accompanying onClick for accessibility
                        if (event.code === 'Enter') {
                            showAllProjects(event);
                        }
                    }}>Show all projects</a>
            </div>
        );
    }

    return null;
}
ShowAllProjectsButton.propTypes = {
    chosenSupportCategory: PropTypes.object.isRequired,

    // TODO showAllProjects and filteredProjects are always checked together;
    //  could probably remove both and simply check for whether the callback exists
    showAllProjects: PropTypes.bool,
    filteredProjects: PropTypes.array,

    // callback for when this "button" is clicked
    // TODO could probably be optional (and this bubbled up the hierarchy); only used if showAllProjects == true
    showAllProjectsCallback: PropTypes.func.isRequired,
};
